import styled, { css } from 'styled-components';
import Flex from '@deprecated-ui/common/Flex';
import color from '@deprecated-ui/_style/color';

export const Box = styled(Flex)`
  background: ${color.light};
  border: 1px solid ${color.gainsboro};
  border-radius: 3px;
`;

export const TableBox = styled(Flex)`
  border-top: 1px solid ${color.gainsboro};
  border-bottom: 1px solid ${color.gainsboro};
`;

// dropdown menu
export const ButtonContainer = styled(Flex)`
  width: 100%;
  padding: 8px 0 0 0;

  button:first-child {
    margin-right: 8px;
  }

  ${
    // @ts-expect-error
    ({ block }) =>
      block &&
      css`
        button:first-child {
          margin-right: 0px;
        }
        button {
          margin: 0px;
          border: none;
          border-top: 1px solid ${color.gainsboro};
        }
      `
  }
`;
